import { connect } from 'react-redux';
import ArtboardHandoff from '../../components/handoff/ArtboardHandoff';
import { hasHandoffData, getArtboardTitle, isHandoffAvailable, } from '../../selectors/handoff';
function mapStateToProps(state) {
    return {
        title: hasHandoffData(state) && getArtboardTitle(state),
        isAvaible: isHandoffAvailable(state),
    };
}
export default connect(mapStateToProps)(ArtboardHandoff);
